import React from "react";
import { Link } from "react-router-dom";
import { siteConfig } from "../Datas/productData";
import "../css/privacy.scss";

const questions = [
  ["How much is delivery?", `Standard tracked delivery is ${siteConfig.formatPrice(siteConfig.standardShipping)} per order.`],
  ["How can I track my order?", "A tracking link is sent by email when your parcel leaves our fulfilment partner."],
  ["Can I return an item?", "Eligible unused items may be returned within 14 days in their original condition and packaging."],
  ["Which payment methods are supported?", "Our payment partner supports Visa, Mastercard, American Express, Apple Pay and Google Pay where available."],
  ["Can I change an order after payment?", "Contact customer care promptly. We cannot guarantee changes once preparation has started."],
  ["How do I contact jeautyfern?", `Customer care is available by email at ${siteConfig.contact.email}.`],
];

function Faqs() {
  return <main className="privacy-page"><header className="privacy-page__hero"><p>Customer care</p><h1>Frequently asked questions</h1><div><p>Useful information about ordering, delivery, returns and payment.</p></div></header>
    <div className="privacy-page__layout"><aside><nav aria-label="Related information"><p>Related</p><Link to="/shipping">Shipping</Link><Link to="/returns">Returns</Link><Link to="/contact">Contact</Link></nav></aside>
      <article className="privacy-page__content">{questions.map(([title, answer], index) => <section key={title}><span>{String(index + 1).padStart(2, "0")}</span><h2>{title}</h2><p>{answer}</p></section>)}</article></div>
  </main>;
}

export default Faqs;
